import { Component, Input } from '@angular/core';
import { BaseComponent } from './base-component';

@Component({
  selector: 'ntx-base-page',
  templateUrl: './base-page.component.html',
  styleUrls: ['./base-page.component.scss'],
})
export class BasePageComponent<T> extends BaseComponent<T> {
  @Input() title: string;
}
